var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShown)?_c('div',{staticClass:"alert",class:_vm.getClassType},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('span',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("x")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }